module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Sturz_ro.18ea8aea.jpg";